export default "/images/444d74fe7d52ce769e89f5e1727e23af.png";